<template lang="pug">
  section
    h3(:class="{ 'is-overlength': classContent.name.length > 22 }")
      span {{ classContent.name }}
    .types
      span.type(v-for="type in classContent.types", :class="`is-${getType(type).type}`")
        font-awesome-icon(:icon="getType(type).icon")
        | {{ getType(type).text }}
    p 成立日期：{{ classContent.date }}
    p 位置：{{ classContent.position }}
    p(v-html="classContent.background")
    .rows.wrapRWD(v-if="classContent.teachers")
      .col.teacher(v-for="teacher in classContent.teachers")
        font-awesome-icon.teacher-more(v-if="teacher.extra", icon="comment-dots", @click="showMore=true")

        span.teacher-icon
          font-awesome-icon(icon="user")
        p.teacher-name {{ teacher.name }}
        p.teacher-des(v-html="teacher.des")

        vue-modaltor(v-if="teacher.extra", :visible="showMore", @hide="hideMore")
          p.teacher-extra(v-html="teacher.extra")
</template>

<script>
export default {
  name: 'ClassCard',
  props: {
    classContent: Object
  },
  data () {
    return {
      typeMap: [
        {
          type: 'english',
          icon: 'language',
          text: '英文'
        },
        {
          type: 'computer',
          icon: 'desktop',
          text: '電腦'
        },
        {
          type: 'chinese',
          icon: 'language',
          text: '中文'
        }
      ],
      showMore: false
    }
  },
  methods: {
    getType (type) {
      const detail = this.typeMap.filter(s => s.type === type)
      return detail[0]
    },
    setPhoto (name) {
      return `/static/images/teachers/${name.toLowerCase().replace(' ', '')}`
    },
    hideMore () {
      this.showMore = false
    }
  }
}
</script>

<style lang="sass" scoped>
section
  padding: 20px 30px
  margin: 20px 0

h3
  +fs($ta: center)
  +pos($p: relative)
  margin: 0 auto 40px
  &::after
    +size($w: 100%, $h: 3px)
    +pos($p: absolute, $t: 44px, $l: 0)
    background-color: $c-primary
    content: ''
    display: block
    z-index: -1
  span
    background-color: #fff
    display: inline-block
    padding: 0 12px
  +rwd(xs)
    &.is-overlength
      &::after
        +pos($t: 50px)
      span
        padding: 0
        display: unset

.types
  +fs($ta: center)
  margin: 20px 0

$typeList: ('computer', #00b894), ('english', #0984e3), ('chinese', #e84393)

.type
  +fs($fz: 18px, $fw: 400)
  vertical-align: middle
  &:not(:first-of-type)
    margin-left: 20px
  @each $type in $typeList
    $name: nth($type, 1)
    $color: nth($type, 2)
    &.is-#{$name}
      +fs($c: #{$color})
  svg
    +fs($fz: 22px)
    margin-right: 6px
    vertical-align: middle

.teacher
  +pos($p: relative)
  padding: 12px
  max-width: 50%
  background-color: rgba(#a29bfe, 0.1)
  border-radius: 4px
  &:not(:first-of-type)
    margin-left: 12px
  +rwd(mbl)
    max-width: 100%
    &:not(:first-of-type)
      margin: 16px 0
  &-more
    +fs($c: $c-primary, $fz: 24px)
    +pos($p: absolute, $t: 20px, $r: 20px)
  &-extra
    padding: 20px 20px 0
  &-icon
    +fs($ta: center, $c: $c-light-grey, $fz: 52px, $lh: 120px)
    +size($w: 120px, $h: 120px)
    border-radius: 50%
    background-color: #fff
    margin: 10px auto 0
    display: block
    +rwd(mbl)
      +fs($fz: 42px, $lh: 100px)
      +size($w: 100px, $h: 100px)
  &-name
    +fs($fz: 20px, $fw: bold, $ta: center)
  &-des
    +fs($fz: 14px, $ta: left)
    padding: 0 12px

</style>



// WEBPACK FOOTER //
// src/components/ClassCard.vue